import { request } from 'utils/request';

const culturesApi = {
  getCultures: () => {
    return request({
      url: 'cultures',
    });
  },

  getCultureById: (cultureId: number) => {
    return request({
      url: `cultures/${cultureId}`,
    });
  },

  getCulturesList: ({
    hiikoEnvironmentId,
    cultureId,
    seasonId,
  }: {
    hiikoEnvironmentId: number;
    cultureId?: number | null;
    seasonId: number;
  }) => {
    let url = `/hiiko_environment/${hiikoEnvironmentId}/cultures`;
    return request({
      url: url,
      params: {
        culture_id: cultureId,
        season_id: seasonId,
      },
    });
  },

  getCompanyCultureById: ({
    hiikoEnvironmentId,
    cultureId,
    companyId,
    seasonId,
  }: {
    hiikoEnvironmentId: number;
    cultureId: number;
    companyId: number;
    seasonId: number;
  }) => {
    return request({
      url: `hiiko_environment/${hiikoEnvironmentId}/cultures/${cultureId}`,
      params: {
        company_id: companyId,
        season_id: seasonId,
      },
    });
  },

  createOrUpdateCompanyCulture: (
    hiikoEnvironmentId: number,
    data: {
      companyId: number;
      cultureId: number;
      fieldSeasonIds: number[];
      harvest: number;
    },
  ) => {
    return request({
      url: `hiiko_environment/${hiikoEnvironmentId}/cultures`,
      method: 'POST',
      data,
    });
  },

  removeCultureFromField: (
    hiikoEnvironmentId: number,
    fieldSeasonIds: (number | undefined)[],
  ) => {
    const data = {
      fieldSeasonIds: fieldSeasonIds,
    };
    return request({
      url: `hiiko_environment/${hiikoEnvironmentId}/cultures/remove`,
      method: 'POST',
      data,
    });
  },
};

export default culturesApi;
